import React from 'react';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-12 md:py-20 bg-navy text-white overflow-hidden relative" data-id="element-160">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#C9A84C 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-161"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-162">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-163">
          <div className="order-2 lg:order-1" data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/25PEcAhFsjEVjhsJohk2WK/imagen_1_codigo_del_credito.png" alt="El Código del Crédito 750+ en Tablet" className="w-full max-w-sm sm:max-w-lg mx-auto drop-shadow-2xl" data-id="element-165" />
          </div>

          <div className="order-1 lg:order-2" data-id="element-166">
            <h2 className="text-gold font-bold tracking-widest uppercase text-xs mb-3" data-id="element-167">
              LA SOLUCIÓN DEFINITIVA
            </h2>
            <h3 className="font-heading text-3xl md:text-5xl font-bold mb-4" data-id="element-168">
              Presentamos{' '}
              <span className="text-gold" data-id="element-169">"El Código del Crédito 750+"</span>
            </h3>

            <p className="text-gray-300 text-base md:text-lg mb-6 leading-relaxed" data-id="element-170">
              No es un curso aburrido. Es un sistema de ataque legal basado en
              la <strong data-id="element-171">Factual Accuracy</strong>. Si la información en tu
              reporte no es 100% exacta y verificable, por ley federal DEBE ser
              eliminada.
            </p>

            <ul className="space-y-4" data-id="element-172">
              {["Aprende a encontrar las 'grietas' legales en tu reporte.", 'Presiona a Experian, Equifax y TransUnion hasta que cedan.', 'Sin abogados costosos ni mensualidades eternas.', 'Diseñado para la mujer latina trabajadora.'].map((item, index) => <li key={index} className="flex items-start" data-id="element-173">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gold flex items-center justify-center mt-0.5 mr-3" data-id="element-174">
                    <CheckIcon className="w-3 h-3 text-navy-dark font-bold" data-id="element-175" />
                  </div>
                  <span className="text-base text-gray-200" data-id="element-176">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}